import React, { Component } from 'react';
import { Modal, Radio, message } from 'antd';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';
import ExportUtil from '../../../common/ExportUtil';

const RadioGroup = Radio.Group;

class ToggleVersion extends Component {
    state = {
        visible: false,
        version: undefined,
    }

    show = () => {
        this.setState({
            visible: true,
            version: undefined,
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    submit = () => {
        const { version } = this.state;
        if (!version) {
            message.warning('请选择要切换的版本');
            return;
        }
        this.hide();
    }

    handleChange = (e) => {
        this.setState({ version: e.target.value });
    }

    render() {
        const { visible, version } = this.state;
        const radioStyle = { marginTop: 10, marginLeft: 6 };
        return (
            <Modal
                title="切换版本"
                visible={visible}
                onOk={this.submit}
                onCancel={this.hide}
                className="create-modal"
                maskClosable={false}
            >
                <div style={{ padding: '0px 10px 10px' }}>
                    <div style={{ padding: 10, background: '#f1f1f1' }}>请选择需要查看的报价单版本：</div>
                    <RadioGroup onChange={this.handleChange} value={version}>
                        <div style={radioStyle}><Radio value="V1">V1</Radio></div>
                        <div style={radioStyle}><Radio value="V2">V2</Radio></div>
                        <div style={radioStyle}><Radio value="V3">V3</Radio></div>
                        <div style={radioStyle}><Radio value="V4">V4</Radio></div>
                    </RadioGroup>
                </div>
            </Modal>
        );
    }
}

export default ToggleVersion;


// WEBPACK FOOTER //
// ./src/components/quotation/Components/ToggleVersion.js